//#region Styles
import { Column, Row, SubtitleSection } from "components/styles";
import { MessageZoomSelected } from "../../styles";
//#endregion
//#region Components
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { VACANCY_RANGE_OPTIONS, CUSTOM_SELECT_PADDING } from "./utils/constants";
//#endregion

const ZoomControls = ({
    dataRelatedToForm: {
        inscriptionTypes
    }, form, changeField,
    errors, errorTexts,
    teacherZoomAccountDetail
}) => {
    //#region Functions
    const changeZoomInscriptionEventTypeId = value => {
        changeField("zoomInscriptionTypeId", value, false);
    }
    const changeZoomTypeId = value => {
        changeField("zoomTypeId", value > 1 
            ? teacherZoomAccountDetail.zoomTypeId 
            : value, false);
    }
    const renderVacancyRangeControls = () => {
        if (!teacherZoomAccountDetail || 
            teacherZoomAccountDetail.zoomTypeId < 2) return null;
        const { zoomTypeId } = form;
        return (
            <Column gap="10px">
                <SubtitleSection>
                    Selecciona el rango de vacantes para el refuerzo:
                </SubtitleSection>
                <Row 
                    maxWidth="max-content" 
                    minWidth="max-content">
                    {VACANCY_RANGE_OPTIONS.map(({
                        id, name
                    }) => (
                        <CustomCheckbox
                            key={id}
                            label={name}
                            checked={(
                                (zoomTypeId === 1 && zoomTypeId === id) ||
                                (zoomTypeId > 1 && id > 1)
                            )}
                            onChange={() => changeZoomTypeId(id)}
                            error={errors.zoomTypeId}
                            padding={CUSTOM_SELECT_PADDING}/>
                    ))}
                </Row>

            </Column>
        );
    }
    //#endregion
    return (
        <Column gap="22px">
            <MessageZoomSelected>
                *Los links serán generados automáticamente
            </MessageZoomSelected>
            <Column gap="15px">
                {renderVacancyRangeControls()}
                {inscriptionTypes &&
                <Column gap="10px">
                    <SubtitleSection>
                        Selecciona el modo de inscripción para el refuerzo:
                    </SubtitleSection>
                    <Row maxWidth="max-content" minWidth="max-content">
                        {inscriptionTypes.map(({
                            id, name
                        }, idx) => (
                            <CustomCheckbox
                                key={idx}
                                label={`Link ${name}`}
                                checked={form.zoomInscriptionTypeId === id}
                                onChange={() => changeZoomInscriptionEventTypeId(id)}
                                error={errors.zoomInscriptionTypeId}
                                padding={CUSTOM_SELECT_PADDING}/>
                        ))}
                    </Row>
                    <ErrorMessage
                        error={errors.zoomInscriptionTypeId}
                        text="Es necesario selección el modo de inscripción."/>
                </Column>}
                {(teacherZoomAccountDetail && teacherZoomAccountDetail.guests > 0) &&
                <MessageZoomSelected>
                    *Recuerda que tu cuenta es para máximo {form?.zoomTypeId === 1 ? 300 : teacherZoomAccountDetail.guests} invitados
                </MessageZoomSelected>}
                {typeof errors?.zoomTypeId !== "undefined" &&
                <ErrorMessage
                    error={errors.zoomTypeId}
                    text={errorTexts.zoomTypeId}/>}
            </Column>
        </Column>
    );
}

export default ZoomControls;